import UserContext from '../contexts/UserContext'
import { DgtPdIAMUser } from '../models'
import { UserRole } from '../components/types'

const UserInfoLayout = ({ 
  children, userGroup, ps, cognitoUser
} : { 
  children: JSX.Element, userGroup: string, ps: any, cognitoUser: any
}) => {
  const responseUser = ps.read()

  let userPayload: { user: {}, readOnly: boolean }
  if (responseUser && responseUser.data.getDgtPdIAMUser) {
    // Online - DDB  
    const ddbUser : DgtPdIAMUser = responseUser.data.getDgtPdIAMUser
    const roles: UserRole[] = ddbUser.roles ? JSON.parse(ddbUser.roles) : []

    let role : UserRole = { name: '', readOnly: false }
    if (roles.length > 0) {
      const currentRole = localStorage.getItem('currentRole')
      const findRole = currentRole ? (roles.find(rl => rl.name === currentRole) || roles[0]) : roles[0]
      role = { 
        name: findRole.name, 
        readOnly: (findRole.readOnly || false)
      }
    }
    userPayload = {
      user: {
        group: userGroup,
        username: ddbUser.username,
        givenName: ddbUser.firstName || '',
        name: `${ddbUser.firstName || ''} ${ddbUser.lastName || ''}`,
        division: ddbUser.division || '',
        role: role.name,
        line: ddbUser.line || '',
        department: ddbUser.department || '',
        allRoles: roles
      },
      readOnly: role.readOnly
    }
    console.log('read profile from ddb', userPayload)
  } else {
    // Offline - Cognito attributes
    userPayload = {
      user: {
        group: userGroup,
        username: cognitoUser.username || '',
        givenName: cognitoUser.attributes?.given_name || '',
        name: cognitoUser?.attributes?.name || '',
        division: cognitoUser.attributes['custom:division'] || cognitoUser.attributes['custom:department'] || '',
        role: cognitoUser.attributes['custom:role'] || userGroup || '',
        line: cognitoUser.attributes['custom:line'] || '',
        department: cognitoUser.attributes['custom:department'] || '',
      },
      readOnly: cognitoUser.attributes['custom:readonly'] === 'true' || false
    }
    console.log('read profile from cognito', userPayload)
  }

  return (
    <UserContext.Provider value={userPayload}>
      {children}
    </UserContext.Provider>
  )
}

export default UserInfoLayout